import { useTranslation } from 'react-i18next';

import type { Product } from '~/api/products/types';

import { useUser } from '~/api/user';
import { Separator } from '~/components';

import type { DialogHandles } from '../ProductsTable.hooks';

import { ProductActivityTypeCell } from './ProductActivityTypeCell';
import { mobileActionsStyle, mobileCellStyle, mobileFooterStyle, mobileHeaderStyle, mobileSeparatorStyle } from './productCell.css';
import { ProductNameCell } from './ProductNameCell';
import { ProductOptionsCell } from './ProductOptionsCell';
import { ProductPriceCell } from './ProductPriceCell';
import { ProductStatusCell } from './ProductStatusCell';

type Props = {
  dialogHandles: DialogHandles;
  product: Product;
};

export const ProductMobileCell = ({ dialogHandles, product }: Props) => {
  const { data: user } = useUser();
  const { t } = useTranslation(['lines']);

  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <ProductNameCell name={product.name[user.lang]} />

        <div className={mobileActionsStyle}>
          <ProductStatusCell status={product.status} />

          <ProductOptionsCell dialogHandles={dialogHandles} product={product} />
        </div>
      </div>

      <Separator className={mobileSeparatorStyle} />

      <div className={mobileFooterStyle}>
        <ProductActivityTypeCell activityType={t(`lines:creativeWork.options.${product.activityType}.label`)} />

        <ProductPriceCell price={product.price ?? undefined} />
      </div>
    </div>
  );
};
